import { render, staticRenderFns } from "./contact-persons-list-edit.vue?vue&type=template&id=ae8da2dc&scoped=true"
import script from "./contact-persons-list-edit.vue?vue&type=script&lang=js"
export * from "./contact-persons-list-edit.vue?vue&type=script&lang=js"
import style0 from "./contact-persons-list-edit.vue?vue&type=style&index=0&id=ae8da2dc&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae8da2dc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/Resourced/Resourced/Frontend-old/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ae8da2dc')) {
      api.createRecord('ae8da2dc', component.options)
    } else {
      api.reload('ae8da2dc', component.options)
    }
    module.hot.accept("./contact-persons-list-edit.vue?vue&type=template&id=ae8da2dc&scoped=true", function () {
      api.rerender('ae8da2dc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "public/pages/supplier/edit-poppers/contact-persons-list-edit.vue"
export default component.exports